import styled from '@emotion/styled';

export const ItemLeftWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const ThumbnailWrapper = styled.div`
  flex-shrink: 0;
  position: relative;
`;

export const ItemTitle = styled.h4`
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  display: inline-flex;
  word-break: break-word;
  align-items: center;
  color: ${({ theme }) => theme.color.content12};
  ${({ theme }) => theme.screenSize.mobile} {
    font-size: 14px;
    line-height: 18px;
  }
`;
